import React, { useEffect } from 'react';
import { useData } from '../context/DataContext';

const Joueurs = () => {
  const { joueurs, joueursLoading, joueursError, fetchJoueurs } = useData();

  useEffect(() => {
    const navbar = document.getElementById('navbar');
    if (navbar) {
      navbar.classList.add('page');
    }

    // Charge les données seulement si elles ne sont pas déjà présentes
    fetchJoueurs();
  }, [fetchJoueurs]);

  if (joueursError) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">
          <strong>Erreur:</strong> {joueursError}
          <button 
            className="btn btn-sm btn-outline-danger ms-2" 
            onClick={() => fetchJoueurs(true)}
          >
            Réessayer
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container container-joueurs">
      <div className="d-flex justify-content-center align-items-center mb-4">
        <h1>Classement des joueurs</h1>
      </div>

    {!Array.isArray(joueurs) || joueurs.length === 0 && (
      <p>Aucun joueur pour le moment.</p>
    )}
      
      {joueursLoading ? (
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Chargement en cours...</span>
          </div>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Nom</th>
                <th scope="col">Prénom</th>
                <th scope="col">Points</th>
              </tr>
            </thead>
            <tbody>
              {joueurs.map((joueur, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{joueur.nom}</td>
                  <td>{joueur.prenom}</td>
                  <td><strong>{joueur.points}</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Joueurs;